const MAX_ALLOWED_IPS = 16;

const addressNumber = (address) => address.split('.').reduce((value, octet) => value * 256 + Number(octet), 0);

// Mirror api/network_validation.py and Python ipaddress's non-global IPv4 ranges.
// The server still validates every request; this only provides immediate feedback.
const blockedRanges = [
  '0.0.0.0/8',
  '10.0.0.0/8',
  '100.64.0.0/10',
  '127.0.0.0/8',
  '169.254.0.0/16',
  '172.16.0.0/12',
  '192.0.0.0/24',
  '192.0.2.0/24',
  '192.168.0.0/16',
  '198.18.0.0/15',
  '198.51.100.0/24',
  '203.0.113.0/24',
  '224.0.0.0/4',
  '240.0.0.0/4',
].map((cidr) => {
  const [address, prefix] = cidr.split('/');
  const start = addressNumber(address);
  return [start, start + 2 ** (32 - Number(prefix)) - 1];
});

const globalExceptions = new Set(['192.0.0.9', '192.0.0.10']);
const ipv4Host = /^(?:(?:0|[1-9]\d{0,2})\.){3}(?:0|[1-9]\d{0,2})(?:\/32)?$/;

function inputError(code) {
  return Object.assign(new Error(code === 'limit' ? 'Too many IP addresses.' : 'A public IPv4 address is required.'), { code });
}

export function createSqlAllowedIpsInput(addresses = []) {
  return { addresses: [...addresses], draft: '' };
}

export function parseSqlAllowedIps(input) {
  if (!input || !Array.isArray(input.addresses) || typeof input.draft !== 'string') throw inputError('invalid');
  const entries = [...input.addresses, ...input.draft.split(/[\s,]+/).filter(Boolean)];
  const normalized = new Map();
  for (const entry of entries) {
    if (typeof entry !== 'string' || entry !== entry.trim() || !ipv4Host.test(entry)) throw inputError('invalid');
    const address = entry.split('/')[0];
    if (address.split('.').some((octet) => Number(octet) > 255)) throw inputError('invalid');
    const number = addressNumber(address);
    if (!globalExceptions.has(address) && blockedRanges.some(([start, end]) => number >= start && number <= end)) {
      throw inputError('invalid');
    }
    normalized.set(number, `${address}/32`);
  }
  if (normalized.size > MAX_ALLOWED_IPS) throw inputError('limit');
  return [...normalized].sort(([left], [right]) => left - right).map(([, cidr]) => cidr);
}
